import {Directive, ElementRef, HostBinding, HostListener, inject, input, output, Renderer2} from '@angular/core';

@Directive({
			   selector: '[OnHold]'
		   })
export class PressHoldDirective {
	private el = inject(ElementRef)
	private renderer = inject(Renderer2)

	holdDuration = input<number>(1000);
	holdDisabled = input<boolean>(false);
	onHold = output<void>();

	@HostBinding('class.pressed') isPressed = false;

	private holdTimeout: any = null;
	private readonly progressBar: HTMLElement;

	constructor() {
		const hostPosition = getComputedStyle(this.el.nativeElement).position;
		if (hostPosition === 'static' || !hostPosition) {
			this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
		}

		this.progressBar = this.renderer.createElement('div');

		this.renderer.setStyle(this.progressBar, 'position', 'absolute');
		this.renderer.setStyle(this.progressBar, 'bottom', '0');
		this.renderer.setStyle(this.progressBar, 'left', '0');
		this.renderer.setStyle(this.progressBar, 'top', '0');
		this.renderer.setStyle(this.progressBar, 'width', '0%');
		this.renderer.setStyle(this.progressBar, 'background', 'repeating-linear-gradient(\n' +
															   '  -55deg,\n' +
															   '  rgba(255, 255, 255, 0.00),\n' +
															   '  rgba(255, 255, 255, 0.00) 0.25rem,\n' +
															   '  rgba(255, 255, 255, 0.25) 0.25rem,\n' +
															   '  rgba(255, 255, 255, 0.25) 0.5rem\n' +
															   ')');
		this.renderer.setStyle(this.progressBar, 'z-index', '-1');
		this.renderer.setStyle(this.progressBar, 'pointer-events', 'none');

		this.renderer.addClass(this.progressBar, 'animate-pulse');

		this.renderer.appendChild(this.el.nativeElement, this.progressBar);
	}

	@HostListener('pointerdown')
	onPressStart(): void {
		if (this.holdDisabled()) return;
		this.isPressed = true;

		// Define a delay before starting the press action
		const startDelay = 300;

		this.holdTimeout = setTimeout(() => {
			// Start progress bar and hold actions only after the delay
			this.renderer.setStyle(this.progressBar, 'transition', `width ${this.holdDuration()}ms linear`);
			this.renderer.setStyle(this.progressBar, 'background-size', `${this.el.nativeElement.offsetWidth}px ${this.el.nativeElement.offsetHeight}px`);
			this.renderer.setStyle(this.progressBar, 'width', '100%');

			// Start the hold duration timer
			this.holdTimeout = setTimeout(() => {
				this.onHold.emit();
				this.resetStates();
			}, this.holdDuration());
		}, startDelay);
	}

	@HostListener('pointerup')
	onPressEnd(): void {
		if (this.holdDisabled()) return;
		this.resetStates();
	}

	@HostListener('pointercancel')
	onPointerCancel(): void {
		this.resetStates(); // Reset state if the pointer event is canceled (e.g., during scrolling)
	}

	resetStates(): void {
		if (this.holdDisabled()) return;
		this.isPressed = false;

		// Reset progress bar
		this.renderer.setStyle(this.progressBar, 'transition', `width 200ms ease-out`);
		this.renderer.setStyle(this.progressBar, 'width', '0%');

		// Cancel any existing timeouts if they exist
		if (this.holdTimeout) {
			clearTimeout(this.holdTimeout);
			this.holdTimeout = null;
		}
	}
}